// This has to be a js file for gatsby-config to import it.

const supportedLanguages = ["en", "da", "no", "is", "sv"]
const supportedLanguagesLabels = new Map([
  ["en", "English"],
  ["da", "Dansk"],
  ["no", "Norsk"],
  ["is", "íslenskur"],
  ["sv", "Svenska"],
])

// For Google Maps API
const supportedAddressCountries = ["dk", "no", "is", "se"]

module.exports = {
  supportedLanguages,
  supportedLanguagesLabels,
  supportedAddressCountries,
}
